import React, { useState, useEffect } from "react"
import SimpleBar from "simplebar-react"
import { useLocation, Link } from "react-router-dom"
import { CSSTransition } from "react-transition-group"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons"
import {
  Nav,
  Badge,
  Image,
  Button,
  Navbar,
  Col,
  Row,
  Accordion,
} from "react-bootstrap"

import { parsedUser } from "../../../common/GetCurrentUser.js"
import { Routes } from "../../../routes.js"

import { useTranslation } from "react-i18next"
import {
  SidebarAdmin,
  SidebarRegular,
  SidebarRegularBackgroundCheck,
} from "./SidebarElements.jsx"

import API from "../../../common/API"

const Sidebar = ({ sidebarToggle, handleSidebarShow, settings }) => {
  const location = useLocation()
  const { pathname } = location
  //let { sectionurl } = useParams()

  const [isCollapse, setIsCollapse] = useState()
  const [show, setShow] = useState(false)

  const showClass = show ? "show" : ""

  //const [showSidebar, setShowSidebar] = useState(false)

  const { t } = useTranslation("global")

  let user = parsedUser()

  const onCollapse = () => {
    setShow(!show)
  }

  const CollapsableNavItem = props => {
    const { eventKey, subCollapsable, title, icon, children = null } = props
    //const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : ""

    const handleIsCollapse = () => {
      if (subCollapsable) {
        setIsCollapse(isCollapse)
      } else {
        setIsCollapse(eventKey === isCollapse ? -1 : eventKey)
      }
    }
    return (
      <Accordion as={Nav.Item} defaultActiveKey={isCollapse}>
        <Accordion.Item eventKey={eventKey}>
          <Accordion.Button
            as={Nav.Link}
            className="d-flex justify-content-between align-items-center"
            onClick={handleIsCollapse}
          >
            <span>
              {icon ? (
                <span className="sidebar-icon">
                  <i className={icon}></i>{" "}
                </span>
              ) : null}
              <span className="sidebar-text">{title}</span>
            </span>
          </Accordion.Button>
          <Accordion.Body className="multi-level ">
            <Nav className="flex-column">{children}</Nav>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    )
  }

  const NavItem = props => {
    const {
      title,
      link,
      external,
      target,
      icon,
      image,
      badgeText,
      badgeBg = "secondary",
      badgeColor = "primary",
    } = props
    const classNames = badgeText
      ? "d-flex justify-content-start align-items-center justify-content-between"
      : ""
    const navItemClassName = link === pathname ? "active" : ""
    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        {external ? (
          <Nav.Link href={link} target={target} className={classNames}>
            <span>
              {icon ? (
                <span className="sidebar-icon">
                  <i className={icon}></i>{" "}
                </span>
              ) : null}
              {image ? (
                <Image
                  src={image}
                  width={32}
                  height={32}
                  className="sidebar-icon svg-icon"
                />
              ) : null}

              <span className="sidebar-text">{title}</span>
            </span>

            {badgeText ? (
              <Badge
                pill
                bg={badgeBg}
                text={badgeColor}
                className="badge-md notification-count ms-2"
              >
                {badgeText}
              </Badge>
            ) : null}
          </Nav.Link>
        ) : (
          <Nav.Link
            as={Link}
            to={link || ""}
            target={target}
            className={classNames}
          >
            <span>
              {icon ? (
                <span className="sidebar-icon">
                  <i className={icon}></i>{" "}
                </span>
              ) : null}
              {image ? (
                <Image
                  src={image}
                  width={32}
                  height={32}
                  className="sidebar-icon svg-icon"
                />
              ) : null}

              <span className="sidebar-text">{title}</span>
            </span>

            {badgeText ? (
              <Badge
                pill
                bg={badgeBg}
                text={badgeColor}
                className="badge-md notification-count ms-2"
              >
                {badgeText}
              </Badge>
            ) : null}
          </Nav.Link>
        )}
      </Nav.Item>
    )
  }

  const Menu = () => {
    if (!settings) {
      return null
    }
    let option = null
    console.log(settings)
    if (settings.application === "admin") {
      option = SidebarAdmin()
    } else {
      option = window.location.href.includes("backgroundcheck")
        ? SidebarRegularBackgroundCheck()
        : SidebarRegular()
    }

    if (!option) {
      return <></>
    }
    return (
      <Nav className="flex-column pt-2 pt-md-0 mainNavbar">
        <h4 className=" mb-4 text-uppercase">{t(option.title)}</h4>
        <Nav.Link
          className="collapse-close d-md-none "
          onClick={onCollapse}
          style={{
            position: "absolute",
            right: "15px",
            top: "15px",
            cursor: "pointer",
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </Nav.Link>
        {option.items &&
          option.items.map((item, index) => {
            console.log(item, user)
            if (item.admin && user.RoleId !== "admin") {
              return null
            }

            if (item.subItems && item.subItems.length > 0) {
              return (
                <CollapsableNavItem
                  key={index}
                  eventKey={item.link}
                  title={t(item.title)}
                  icon={item.icon}
                >
                  {item.subItems.map((subItem, index) => {
                    return (
                      <NavItem
                        key={index}
                        external={false}
                        title={t(subItem.title)}
                        link={subItem.link}
                        icon={subItem.icon}
                      ></NavItem>
                    )
                  })}
                </CollapsableNavItem>
              )
            }
            return (
              <NavItem
                tag={Link}
                key={index}
                external={false}
                title={t(item.title)}
                link={item.link}
                icon={item.icon}
                className="py-1"
              ></NavItem>
            )
          })}

        {/* {OrganizationUI(user, organizations)} */}
      </Nav>
    )
  }
  const ContentSidebar = () => {
    return (
      <>
        <div className="container sidebar-inner p-0">
          <Row className="mx-0">
            <Col>
              <div className="flex-column">
                <Menu />
              </div>
              {/* <UserButton /> */}

              {/* {OrganizationUI(user, organizations)} */}
            </Col>
          </Row>
        </div>
      </>
    )
  }
  const requestOrganizations = async () => {
    if (user === null) {
      return
    }
    let requestAPI = await API.getAction(
      "Organization/OrganizationsWhereTheUserBelong?AccountId=" + user.ID,
    )
    if (requestAPI.data.status === "ok") {
      localStorage.setItem(
        "organization",
        JSON.stringify(
          requestAPI.data.response.filter(
            org => org.Id !== user.OrganizationId,
          )[0],
        ),
      )
    }
  }
  const [currentOrganization, setCurrentOrganization] = useState({ name: "" })
  useEffect(() => {
    requestOrganizations()

    let currntOrg = localStorage.getItem("organization")
    if (currntOrg && currntOrg !== "undefined") {
      try {
        setCurrentOrganization(JSON.parse(currntOrg))
      } catch (error) {
        console.error("Invalid organization in storage", error)
        setCurrentOrganization({ name: "" })
      }
    }
  }, [])
  return (
    <>
      <Navbar
        expand={false}
        collapseOnSelect
        variant="dark"
        className="navbar-theme-primary px-4 d-md-none primaryNavBarWithLogo"
      >
        <Navbar.Toggle
          as={Button}
          aria-controls="main-navbar"
          onClick={() => {
            if (!sidebarToggle) {
              handleSidebarShow()
            }
            onCollapse()
          }}
        >
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
        <Navbar.Brand className="me-lg-5" as="div">
          {/* <img
            src="/icons/32x32-icon.png"
            alt="data-worker"
            className="navbar-brand-light"
          /> */}
          <Link
            to={Routes.SelectOrganization.path}
            className="display-5 clickable px-2 text-white"
          >
            {currentOrganization?.name}
            <i className="fas fa-chevron-down ms-2"></i>
          </Link>
        </Navbar.Brand>
      </Navbar>
      <button
        type="button"
        className={
          sidebarToggle
            ? "btn button-toggle text-white"
            : "btn button-toggle rotate bg-dark text-white ms-3 "
        }
        onClick={handleSidebarShow}
      >
        <FontAwesomeIcon
          className="fa-lg"
          icon={sidebarToggle ? faBars : faBars}
        />
      </button>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar
          className={`collapse ${showClass} sidebar d-md-inline-block bg-primary text-white`}
          style={
            sidebarToggle
              ? { transition: "width 1s 0.3s" }
              : { width: "0px", transition: "width 0.3s" }
          }
        >
          <ContentSidebar></ContentSidebar>
        </SimpleBar>
      </CSSTransition>
    </>
  )
}

export default Sidebar
